/**
 * @sentry/replay and @sentry/core gate debug logging and iframe/shadow-DOM/
 * compression-worker recording behind these exact global identifiers, meant to
 * be set via a bundler's compile-time define (e.g. webpack's DefinePlugin) so
 * the excluded code paths can be tree-shaken out. Turbopack has no equivalent
 * public API for arbitrary global defines, so this sets them as real runtime
 * globals instead — read by `typeof X === 'boolean'` checks inside those
 * packages, so a runtime assignment is observationally identical to a
 * compile-time define from the read side. Bundler-agnostic since it works
 * before the first line of the actual application runs (Next.js's
 * `instrumentation-client` convention loads before anything else on both
 * webpack and Turbopack; see apps/*\/src/instrumentation-client.ts).
 *
 * Values match what `packages/next/src/server/config.ts`'s webpack customizer
 * used to set via DefinePlugin. Leaving `__SENTRY_DEBUG__` unset would be
 * low-risk in practice (its own logger no-ops unless `Sentry.init({debug})` is
 * true), but the other three are real behavior, not just bundle-size: without
 * them, iframe/shadow-DOM content and the replay compression worker start
 * getting recorded/loaded when they were meant to be excluded.
 */
export const configureReplayTreeShakingGlobals = () => {
  Object.assign(globalThis, {
    __SENTRY_DEBUG__: false,
    __RRWEB_EXCLUDE_IFRAME__: true,
    __RRWEB_EXCLUDE_SHADOW_DOM__: true,
    __SENTRY_EXCLUDE_REPLAY_WORKER__: true,
  });
};
